import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { PromotionEnumType } from '../../../enums/promotionEnum';
import { useTranslation } from 'react-i18next';

interface Props {
  value: PromotionEnumType,
  onChange: (value: PromotionEnumType) => void
}

const PromotionTabPanel = ({ value, onChange }: Props) => {
  const { t } = useTranslation("global");

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={(_: any, newValue: PromotionEnumType) => {
          onChange(newValue)
        }} variant='scrollable'>
          <Tab label={t("promotion_page.Buy x get x")} value={PromotionEnumType.buy_x_get_x} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.Buy x get y")} value={PromotionEnumType.buy_x_get_y} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.Buy x get discount(DS)")} value={PromotionEnumType.buy_x_get_ds} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.buy_x_u_get_spp")} value={PromotionEnumType.buy_x_u_get_spp} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.buy_x_set_a_get_cbp")} value={PromotionEnumType.buy_x_set_a_get_cbp} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.buy_x_set_u_get_cbd")} value={PromotionEnumType.buy_x_set_u_get_cbd} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.buy_x_set_a_get_rd")} value={PromotionEnumType.buy_x_set_a_get_rd} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.buy_x_set_u_get_cst_by_unit")} value={PromotionEnumType.buy_x_set_u_get_cst_by_unit} sx={{ textTransform: 'none' }} />
          <Tab label={t("promotion_page.buy_x_set_a_get_cst_by_price")} value={PromotionEnumType.buy_x_set_a_get_cst_by_price} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
    </Box>
  );
}


export default PromotionTabPanel